export const tiktok = {
  tiktok: {
    shape:
      '<path fill="#3d3d3d" d="M25.49 10.52a5.25 5.25 0 0 1-3.72-1.54 5.25 5.25 0 0 1-1.53-3.72h-3.76v14.7A3.19 3.19 0 0 1 14.3 23a3.19 3.19 0 0 1-3.56-1.12 3.19 3.19 0 0 1-.06-3.74 3.19 3.19 0 0 1 3.52-1.23v-3.65a6.77 6.77 0 1 0 5.87 6.71l.1-7.43a8.96 8.96 0 0 0 5.33 1.74v-3.75z"/>',
    viewBox: [0, 0, 32, 32],
  },
};
